import './AppointmentTaskComponent.scss';
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import ProgressBarComponent from "../../../../shared/components/progress-bar/ProgressBarComponent";
import CardComponent from "../../../../shared/components/card/CardComponent";
import {ImageConfig} from "../../../../constants";
import ChipComponent from "../../../../shared/components/chip/ChipComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";
import {useNavigate} from "react-router-dom";
import {CommonService} from "../../../../shared/services";

interface AppointmentTaskComponentProps {
    formStatus: any;
    appointmentDetails?: any;
}

const AppointmentTaskComponent = (props: AppointmentTaskComponentProps) => {
    const {formStatus, appointmentDetails} = props;
    const navigate = useNavigate();

    return (
        <div className={'appointment-task-component'}>
            <CardComponent>
                <div className={'appointment-task-component__header'}>
                    <div className={'appointment-task-component__header-title'}>
                        <div className={'appointment-task-component__header-title__text'}>Appointment Tasks
                        </div>
                        <div className={'appointment-task-component__header-title__subtext'}>Please
                            complete/review
                            the
                            following before your next appointment.
                        </div>
                    </div>
                    {appointmentDetails?.status === 'scheduled' && appointmentDetails?.appointment_type === 'initial_consultation' && formStatus?.percentage_of_form_filled !== 100 &&
                        <ButtonComponent
                            onClick={() => navigate(CommonService._routeConfig.ClientOnboarding() + '?appointmentId=' + appointmentDetails?._id)}>
                            Fill/Review Forms
                        </ButtonComponent>}
                </div>
                {appointmentDetails?.appointment_type === 'initial_consultation' ?

                    <>
                        <div className={'ts-row'}>
                            <div
                                className={'ts-col-lg-6 ts-col-md-12 ts-col-sm-12 ts-col-xs-12 portal-registration-section'}>
                                <div className={'portal-registration-section__title'}>Portal Registration</div>
                                <div className={'portal-registration-section__description'}>The progress bar below
                                    indicates
                                    how
                                    much of your registration is complete. Please ensure it is fully completed prior
                                    to
                                    your
                                    appointment.
                                </div>
                                <ProgressBarComponent progress={formStatus?.percentage_of_form_filled}/>
                                <div
                                    className={'progress-bar-text'}>{CommonService.convertToDecimals(formStatus?.percentage_of_form_filled) || 0}%
                                    of
                                    your
                                    registration is complete.
                                </div>
                            </div>
                            <div className={'ts-col-lg-6 ts-col-md-12 ts-col-sm-12 ts-col-xs-12'}>
                                {appointmentDetails?.service_category_config_type === 'configuration_2' &&
                                    <div className={'ts-col form-status-section mrg-bottom-20'}>
                                        <div className={'form-status-section__title-wrapper'}>
                                            <div className={'image-wrapper'}>
                                                <ImageConfig.DocumentIcon2/>
                                            </div>
                                            <div>
                                                Physical Activity Questionnaire
                                            </div>
                                        </div>
                                        <ChipComponent
                                            label={formStatus?.is_physical_activity_form_filled ? 'Completed' : 'Pending'}
                                            className={formStatus?.is_physical_activity_form_filled ? 'completed' : 'pending'}
                                        />
                                    </div>}
                                {appointmentDetails?.service_category_config_type === 'configuration_1' &&
                                    <div className={'ts-col form-status-section mrg-bottom-20'}>
                                        <div className={'form-status-section__title-wrapper'}>
                                            <div className={'image-wrapper'}>
                                                <ImageConfig.DocumentIcon2/>
                                            </div>
                                            <div>
                                                New Injury/Condition Information
                                            </div>
                                        </div>
                                        <ChipComponent
                                            label={formStatus?.is_injury_form_filled ? 'Completed' : 'Pending'}
                                            className={formStatus?.is_injury_form_filled ? 'completed' : 'pending'}
                                        />
                                    </div>}
                                <div className={'ts-col form-status-section'}>
                                    <div className={'form-status-section__title-wrapper'}>
                                        <div className={'image-wrapper'}>
                                            <ImageConfig.DocumentIcon2/>
                                        </div>
                                        <div>
                                            Authorization to Disclose Protected Health
                                            Information
                                        </div>
                                    </div>
                                    <ChipComponent
                                        label={formStatus?.is_authorization_disclose_info_form_filled ? 'Completed' : 'Pending'}
                                        className={formStatus?.is_authorization_disclose_info_form_filled ? 'completed' : 'pending'}
                                    />
                                </div>
                            </div>

                        </div>
                    </> : <StatusCardComponent title={'No forms to complete/review.'}
                                               className={'no-forms pdd-top-20 pdd-bottom-30'}/>
                }
            </CardComponent>
        </div>
    )
}

export default AppointmentTaskComponent
